import { useCallback, type PropsWithChildren } from 'react';
import { useNavigate } from 'react-router';

import { useTelegramBackButton } from '@/shared/hooks';

export function Page({
  children,
  back = true,
}: PropsWithChildren<{
  /**
   * True if it is allowed to go back from this page.
   */
  back?: boolean;
}>) {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    void navigate(-1);
  }, [navigate]);

  useTelegramBackButton({ visible: back, onBack: handleBack });

  return <>{children}</>;
}
